export default __webpack_public_path__ + "static/media/eleven_one-min.53ac3e96.png";